import React from "react";
import styles from "./PopupFooter.scss";

export const PopupFooter = ({ children }) => {
    return <div className={styles.footer}>{children}</div>;
};
